import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from 'src/app/shared/services/url.service';
import { GlobalService } from 'src/app/shared/global.service';
import { AlertService } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'consultar-informacion-codigo',
  templateUrl: './consultar-informacion-codigo.component.html',
  styleUrls: ['./consultar-informacion-codigo.component.scss']
})
export class ConsultarInformacionCodigoComponent implements OnInit {

  @Input() data: any;
  public informacionCodigo: [];

  constructor(
    private activeModal: NgbActiveModal,
    private global: GlobalService,
    private urlService: UrlService,
    private spinner: NgxSpinnerService,
    private alertService: AlertService
  ) {
  }

  ngOnInit() {
    this.ConsultarCodigo();
  }

  /**
   * Método que consulta la informacion respecto aun codigo
   */
  ConsultarCodigo() {
    this.spinner.show();
    const serviceProvider = 'consultarInformacionCodigo';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
    this.global.postGenerico(url, this.data).subscribe(
      data => {
        this.informacionCodigo = data;
        this.spinner.hide();
      }, err => {
        this.spinner.hide();
        if (err.status === '500') {
          this.cathException(err.error.message);
          this.close(0);
        } else {
          this.cathException('No se pudo consultar la informacion respecto al codigo');
        }
      });
  }

 /**
  * Método para cerrar el modal activo
  */
  close(tipo) {
    this.activeModal.close({ accion: tipo[1], respuesta: tipo[0] });
  }

    /**
     * Método de control de Excepciones
     */
  cathException(error) {
    this.alertService.generateAlertError(error, 'Error');
    this.spinner.hide();
  }
}
